import React, { CSSProperties } from 'react';
import PropTypes from 'prop-types';
import Styles from './styles/unit.less';

export interface IUnitProps {
    unitStr: string;
    style?: CSSProperties;
}

export const Unit: React.FC<IUnitProps> = ({ unitStr, style }) => (
    <span style={style} className={`${Styles.unselectable} ${Styles['para-panel-item-unit']}`}>
        {unitStr}
    </span>
);

Unit.propTypes = {
    unitStr: PropTypes.string.isRequired,
    style: PropTypes.object,
};

export default Unit;
